import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedInUser } from './mockFullLoggedInUser';

export const mockLoggedInUserNoConsent: MockResponseConfig = {
  ...mockFullLoggedInUser,
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          ...mockFullLoggedInUser.UnifiedProfileQuery(variables).data.unified
            .unifiedProfile,
          username: 'loggedinnoconsent',
          isProfileOwnerConsented: false,
        },
      },
    },
  }),
}; 